import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { app, usingEmulators } from './app';

// Només el carrega la pantalla de fotos de la gestió: la part pública mostra les fotos amb URL directes.
export const storage = getStorage(app);
if (usingEmulators) connectStorageEmulator(storage, '127.0.0.1', 9199);
